import { render, staticRenderFns } from "./modalClaimDetail.vue?vue&type=template&id=0aeda3ee&"
import script from "./modalClaimDetail.vue?vue&type=script&lang=js&"
export * from "./modalClaimDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports